import { Text, VStack } from "@chakra-ui/react";
import { useAPI } from "@/contexts/APIContext";
import { useEffect, useState } from "react";
import { RatePopover } from "@/components/shared/Popovers/RatePopover";

export const RateProfile = ({ currentUser, profile }) => {
  const api = useAPI();

  const [currentReview, setCurrentReview] = useState(null);
  const [isRated, setIsRated] = useState(false);

  const sendReview = async (rating, comment) => {
    if (currentUser && profile) {
      await api.post("profiles/write-review/", currentUser, {
        profileId: profile.id,
        userId: currentUser.uid,
        rating,
        comment,
      });

      setCurrentReview({ rating, comment });

      setIsRated(true);
    }
  };

  useEffect(() => {
    if (!currentUser || !profile) {
      return;
    }

    if (!profile.reviews || profile.reviews?.length === 0) {
      setCurrentReview({
        rating: 0,
        comment: "",
      });

      setIsRated(false);

      return;
    }

    profile.reviews.forEach((review) => {
      if (review.userId === currentUser?.uid) {
        setCurrentReview(review);

        setIsRated(true);
      }
    });
  }, [profile, currentUser?.uid]);

  return (
    <VStack align="flex-start">
      {!!currentReview && isRated ? (
        <Text fontSize={{ base: "xl", md: "md" }}>Your rating for this profile is:</Text>
      ) : (
        <Text fontSize={{ base: "xl", md: "md" }}>Rate this profile:</Text>
      )}

      <RatePopover
        onSend={sendReview}
        defaultComment={currentReview?.comment}
        defaultRating={currentReview?.rating}
      />
    </VStack>
  );
};
